export default function Ingredients() {
  const ingredients = [
    {
      name: '過酸化水素（H₂O₂）とは',
      description: '過酸化水素は、歯科医療において長年使用されてきた安全性の高い漂白成分です。歯のエナメル質に浸透し、着色の原因となる有機色素分子を酸化分解することで、歯を内側から白くします。市販のホワイトニング製品に含まれる濃度は低く効果が限定的ですが、当サービスでは歯科医師の管理のもと、医療用濃度の過酸化水素を使用するため、短期間で目に見える白さを実現できます。また、適切な濃度・使用方法を守ることで、歯や歯茎への負担を最小限に抑えながら安全にご使用いただけます。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Visual */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border-4 border-[#E3F2FD] shadow-xl">
              <img 
                src="https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/98d77216fa26f1e3e14ce9e09913d643.png" 
                alt="医療用成分"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          {/* Right Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-[#E3F2FD] text-[#2C5AA0] text-sm font-semibold rounded-full mb-6">
              医療用成分について
            </span>
            
            <h2 className="text-3xl font-bold text-gray-900 mb-6 leading-tight">
              医療用成分配合で、<br />確かな白さを実現
            </h2>
            
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              当サービスで使用するホワイトニングシートには、歯科医院でのみ取り扱いが許可されている<span className="font-bold text-[#4A90E2]">医療用成分</span>を配合しています。市販品では実現できない高い漂白効果と、歯科医師の管理下での安全性を両立させた製品です。
            </p>

            <div className="space-y-5">
              {ingredients.map((ingredient, index) => (
                <div key={index} className="bg-[#F0F7FF] rounded-2xl p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-8 h-8 bg-[#4A90E2] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-flask-line text-white text-sm"></i>
                    </div>
                    <h4 className="font-bold text-gray-900 text-lg">{ingredient.name}</h4>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed">{ingredient.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 border border-[#4A90E2]/30 rounded-xl bg-[#F8FBFF]">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-shield-check-line text-[#4A90E2] text-lg"></i>
                </div>
                <p className="text-xs text-gray-500 leading-relaxed">
                  過酸化水素を含む医療用ホワイトニング製品は、日本では歯科医師の処方・管理のもとでのみ使用が認められています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
